import Cart from './cart'

const contextSwitcher = () => ({
    swapCurrency(currency) {
        const params = new URLSearchParams()
        params.append('c', currency.id)

        window.api.post('/api/update-context', params).then(() => {
            Cart({ selfId: 'anon', step: null }).loadCart()
            window.dispatchEvent(new CustomEvent('currency-updated'))
        })
    },
    setProductAsViewed(productId) {
        const params = new URLSearchParams()
        params.append('id', productId)

        window.api.post('/api/mark-product-viewed', params)
    },
    toggleTax(override = null, options = {}) {
        window.Alpine.store('settings').include_tax = (override !== null) ? override : !window.Alpine.store('settings').include_tax
        window.dispatchEvent(new CustomEvent('tax-toggled', { detail: options }))
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('contextSwitcher', contextSwitcher)
})
window.contextSwitcher = contextSwitcher
